import moment, { Moment } from 'moment'

import TimeRange from '../../app/timeRange'

class SnapshotModel {
    public static fromParameters = (parameters: { date?: string; end?: string }): SnapshotModel => {
        return new SnapshotModel('date' in parameters ? parameters.date + 'Z' : null, 'end' in parameters ? parameters.end + 'Z' : null)
    }

    public static fromDataSets = (dataSet: { date?: string }, nextDataSet: { date?: string }): SnapshotModel => {
        return new SnapshotModel('date' in dataSet ? dataSet.date : null, 'date' in nextDataSet ? nextDataSet.date : null)
    }

    private startDate: Moment
    private endDate: Moment

    constructor(start?: string | null, end?: string | null) {
        if (start) {
            this.setStartDate(start)
        }

        if (end) {
            this.setEndDate(end)
        }

        if (!start && !end) {
            this.setEndDate(moment().format())
        }
    }

    public setStartDate = (startDate: string): void => {
        this.startDate = moment
            .utc(startDate)
            .endOf('minute')
            .subtract(59, 'second')

        if (!this.endDate || this.endDate.isBefore(this.startDate)) {
            this.setEndDate(
                moment(this.startDate)
                    .utc()
                    .add(1, 'minute')
                    .format(),
            )
        }
    }

    public setEndDate = (endDate: string): void => {
        this.endDate = moment
            .utc(endDate)
            .subtract(1, 'second')
            .endOf('minute')

        if (!this.startDate || this.startDate.isAfter(this.endDate)) {
            this.setStartDate(
                moment(this.endDate)
                    .utc()
                    .subtract(59, 'second')
                    .format(),
            )
        }
    }

    public getStartDate = (): moment.Moment => this.startDate

    public getEndDate = (): moment.Moment => this.endDate

    public getMinutes = (): number => {
        const end = moment(this.endDate).add(1, 'second')

        return moment.duration(end.diff(this.startDate)).asMinutes()
    }

    public toParameters = (): { date: string; end: string } => ({
        date: this.startDate.format('YYYY-MM-DD HH:mm:ss'),
        end: this.endDate.format('YYYY-MM-DD HH:mm:ss'),
    })

    public toMinMaxDate = (): { minDate: string; maxDate: string } => ({
        minDate: this.getStartDate().format('YYYY-MM-DD HH:mm:ss'),
        maxDate: this.getEndDate().format('YYYY-MM-DD HH:mm:ss'),
    })

    public toRange = (): { ts: string | null; m: number } => {
        const end = moment(this.endDate).add(1, 'second')

        const timeRange = new TimeRange(this.endDate.format(), moment.duration(end.diff(this.startDate)))

        return timeRange.toParameters()
    }

    public getRangeMarker = (): Array<{ start: moment.Moment; end: moment.Moment; type: string }> => {
        if (!this.startDate) {
            return []
        }

        return [{ start: this.startDate.local(), end: this.endDate.local(), type: 'snapshot' }]
    }
}

export default SnapshotModel
